var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSrcPortalIconsCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 270 270",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-md-calendar",
    "data-name": "Icon ionic-md-calendar",
    d: "M213.76,146.25h-67.5v67.5h67.5v-67.5ZM191.25,0v22.5h-112.51V0h-33.73v22.5h-16.88C12.6,22.53.03,35.11,0,50.62v191.25c.03,15.52,12.6,28.09,28.12,28.12h213.76c15.52-.03,28.09-12.6,28.12-28.12V50.62c-.03-15.52-12.6-28.09-28.12-28.12h-16.87V0h-33.75ZM241.88,241.88H28.12V92.83h213.76v149.05Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSrcPortalIconsCalendar);
export default __webpack_public_path__ + "static/media/SRC-Portal-Icons_Calendar.a7330be65789dd1338397411c4658ee5.svg";
export { ForwardRef as ReactComponent };